// utils/formatPhone.js
import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Format any phone number to international format
 * @param {string} phone - input phone number
 * @param {string} defaultCountry - e.g. 'US', 'BD', etc.
 * @returns formatted phone number or original if parse fails
 */
export const formatPhone = (phone, defaultCountry = "US") => {
  if (!phone) return "";

  try {
    // Remove spaces/dashes for safer parse
    const cleanPhone = phone.replace(/\s+/g, "").replace(/-/g, "");

    // Try parsing directly
    let parsed = parsePhoneNumberFromString(cleanPhone);

    if (!parsed)
      parsed = parsePhoneNumberFromString(cleanPhone, defaultCountry);

    if (parsed && parsed.isValid()) {
      return parsed.formatInternational(); // e.g., +1 660 217 1997
    }

    return phone; // fallback: return original
  } catch (err) {
    return phone;
  }
};
